import styled, { css } from 'styled-components';
import { COLORS, SIZING } from '../../styles/variables';
import { device } from '../../styles/devices';

export const AudiCodeContainer = styled.div`
  z-index: 1;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-left: 6px;
  align-self: flex-start;
  margin-bottom: ${SIZING.unit(3)};
  margin-top: ${SIZING.unit(5)};
  @media ${device.tablet} {
    margin-bottom: 24px;
    flex: 2 0 150px;
    align-items: flex-start;
    margin-left: 0px;
    align-self: auto;
    margin-top: ${SIZING.unit(6)};
  }
  @media ${device.laptop} {
    margin-top: 0;
    justify-content: flex-end;
  }
`;

export const Label = styled.p`
  font-size: 16px;
  font-weight: 400;
  text-align: right;
  line-height: 24px;
  margin-right: 6px;
  letter-spacing: 0.003px;
  color: ${COLORS.grey80};
`;

export const AudiCode = styled.p`
  font-weight: 700;
`;

export const Vin = styled.p`
  font-weight: 700;
`;

export const VinWrapper = styled.div`
  width: 100%;
  align-items: center;
  justify-content: flex-end;
  display: flex;
  margin-bottom: ${SIZING.unit(1)};
`;

export const CodeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  @media ${device.laptop} {
    align-items: flex-end;
  }
`;

export const AudiCodeWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  line-height: 24px;

  .popover-styles {
    background-color: ${COLORS.grey80};

    @media ${device.desktop} {
      > svg {
        left: 125px !important;
      }
    }

    polygon {
      fill: ${COLORS.grey80};
    }
  }
`;
export const Copy = styled.p`
  font-family: 'Audi Type';
  font-size: 12px;
  line-height: 15px;
  color: ${COLORS.grey5};
  @media ${device.tablet} {
    font-size: 13px;
    line-height: 21px;
  }
`;

export const StyledInfoButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 1px 6px;
`;
